import en from './en'
import zhTw from './zhTw';

export default {
    en,
    zhTw
}